import React, { useEffect, useState } from 'react';

import { Input, Label, UncontrolledTooltip } from 'reactstrap';

const PASSWORD_RULES = [
  { test: (v) => v.length >= 8, label: 'Mínimo 8 caracteres' },
  { test: (v) => /[a-z]/.test(v), label: 'Letra minúscula' },
  { test: (v) => /[A-Z]/.test(v), label: 'Letra maiúscula' },
  { test: (v) => /[0-9]/.test(v), label: 'Número' },
  { test: (v) => /[^a-zA-Z0-9]/.test(v), label: 'Caractere especial (ex: #, %, @, ^)' },
];

export default function PasswordDisplay({ attributes, rowId, colId, setValue }) {
  const [maskedValue, setMaskedValue] = useState(attributes.value ?? '');
  const [compareValue, setCompareValue] = useState(attributes.value ?? '');

  // Visibilidade das senhas
  const [viewPass, setViewPass] = useState(false);
  const [viewConfirmPass, setViewConfirmPass] = useState(false);

  useEffect(() => {
    const html = attributes.label;
    const div = document.getElementsByClassName(`password-label-${rowId}-${colId}`);

    for (const element of div) {
      element.innerHTML = html + (attributes.required ? '*' : '');
    }
  }, [attributes, rowId, colId]);

  useEffect(() => {
    setValue((oldValue) => {
      const newValue = [...oldValue];
      newValue[rowId].cols[colId].attributes.value = maskedValue;

      let errorMessage = '';
      let useRawErrorMessage = false;

      if (maskedValue === '' && attributes.required) {
        errorMessage = 'Campo obrigatório';
      } else if (maskedValue !== '') {
        const failedRules = PASSWORD_RULES.filter((r) => !r.test(maskedValue));
        if (failedRules.length > 0) {
          errorMessage = 'Senha não atende aos requisitos obrigatórios.';
          useRawErrorMessage = true;
        } else if (compareValue === '') {
          errorMessage = 'Confirme sua senha.';
          useRawErrorMessage = true;
        } else if (compareValue !== maskedValue) {
          errorMessage = 'As senhas não conferem.';
          useRawErrorMessage = true;
        }
      }

      newValue[rowId].cols[colId].attributes.errorMessage = errorMessage;
      newValue[rowId].cols[colId].attributes.useRawErrorMessage = useRawErrorMessage;
      return newValue;
    });
  }, [maskedValue, compareValue, setValue, rowId, colId, attributes]);

  return (
    <div>
      <div className="custom-input-container">
        <div className="displayed-config-container">
          <div className="displayed-label">
            {/* FIX_SSR_LABEL */}
            <Label
              htmlFor="formText"
              className={`form-label password-label-${rowId}-${colId}`}
              style={{ display: "inline", marginRight: 2 }}
            >
              {attributes.label}
            </Label>
            {attributes.hasTip && (
              <div>
                <div className="show-tips" id={`password-tip-${rowId}-${colId}`}>
                  <span>?</span>
                </div>
                <UncontrolledTooltip style={{ backgroundColor: '#6f42c1' }} placement="right" target={`password-tip-${rowId}-${colId}`}>
                  {attributes.tipText}
                </UncontrolledTooltip>
              </div>
            )}
          </div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', marginBottom: 8 }}>
          <span style={{ fontWeight: 'bold', fontSize: '0.85em' }}>A senha deve ter:</span>
          {PASSWORD_RULES.map((rule, i) => (
            <span key={i} style={{ fontSize: '0.85em' }}>• {rule.label}</span>
          ))}
        </div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Input
            className="form-control"
            type={viewPass ? 'text' : 'password'}
            id="formText"
            placeholder={attributes.placeholder}
            value={maskedValue}
            onChange={({ target }) => setMaskedValue(target.value)}
          />
          <a onClick={() => setViewPass(!viewPass)} style={{ cursor: 'pointer' }}>
            {viewPass
              ? <i className="mdi mdi-eye-off-outline icon-password" />
              : <i className="mdi mdi-eye-outline icon-password" />
            }
          </a>
        </div>
      </div>
      <div>
        <Label>
          Confirmar senha{attributes.required && '*'}
        </Label>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Input
            className="form-control"
            type={viewConfirmPass ? 'text' : 'password'}
            id="formText"
            placeholder={attributes.placeholder}
            value={compareValue}
            onChange={({ target }) => setCompareValue(target.value)}
          />
          <a onClick={() => setViewConfirmPass(!viewConfirmPass)} style={{ cursor: 'pointer' }}>
            {viewConfirmPass
              ? <i className="mdi mdi-eye-off-outline icon-password" />
              : <i className="mdi mdi-eye-outline icon-password" />
            }
          </a>
        </div>
      </div>
    </div>
  );
}
